import dayjs from "dayjs"
import localizedFormat from "dayjs/plugin/localizedFormat"
import timezone from "dayjs/plugin/timezone"

import "dayjs/locale/en"
import "dayjs/locale/en-ca"
import "dayjs/locale/es-mx"
import "dayjs/locale/en-au"

dayjs.extend(localizedFormat)
dayjs.extend(timezone)

export enum Country {
  US = "United States",
  CA = "Canada",
  MX = "Mexico",
  AU = "Australia",
}

export enum Locale {
  US = "en",
  CA = "en-ca",
  MX = "es-mx",
  AU = "en-au",
}

export const COUNTRY_TO_LOCALE_MAPPING: Record<Country, Locale> = {
  [Country.US]: Locale.US,
  [Country.CA]: Locale.CA,
  [Country.MX]: Locale.MX,
  [Country.AU]: Locale.AU,
}

const en = dayjs.Ls.en
const enCa = dayjs.Ls["en-ca"]
const esMx = dayjs.Ls["es-mx"]
const enAu = dayjs.Ls["en-au"]
const englishMonths = en.months
const englishMonthsShort = en.monthsShort

dayjs.locale({
  ...en,
  name: Locale.US,
  months: englishMonths,
  monthsShort: englishMonthsShort,
  formats: {
    ...en.formats,
    L: "MM/DD/YYYY",
    LL: "MMM DD, YYYY",
    LT: "hh:mm A",
    LLL: "MM/DD/YYYY hh:mm A",
    LLLL: "MM/DD/YYYY hh:mm:ss A",
  },
})

dayjs.locale({
  ...enCa,
  name: Locale.CA,
  months: englishMonths,
  monthsShort: englishMonthsShort,
  formats: {
    ...enCa.formats,
    L: "MM/DD/YYYY",
    LL: "MMM DD, YYYY",
    LT: "hh:mm A",
    LLL: "MM/DD/YYYY hh:mm A",
    LLLL: "MM/DD/YYYY hh:mm:ss A",
  },
})

dayjs.locale({
  ...esMx,
  name: Locale.MX,
  months: englishMonths,
  monthsShort: englishMonthsShort,
  formats: {
    ...esMx.formats,
    L: "DD/MM/YYYY",
    LL: "DD MMM YYYY",
    LT: "hh:mm A",
    LLL: "DD/MM/YYYY hh:mm A",
    LLLL: "DD/MM/YYYY hh:mm:ss A",
  },
})

dayjs.locale({
  ...enAu,
  name: Locale.AU,
  months: englishMonths,
  monthsShort: englishMonthsShort,
  formats: {
    ...enAu.formats,
    L: "MM/DD/YYYY",
    LL: "MMM DD, YYYY",
    LT: "h:mm A",
    LLL: "MM/DD/YYYY h:mm A",
    LLLL: "MM/DD/YYYY h:mm:ss A",
  },
})

dayjs.locale(Locale.US)

export default dayjs
